import './Popup.less';
import React from 'react';
import LayoutPortal from "../layout-portal/LayoutPortal";
import Icon from "../icon/Icon";

export default class Popup extends React.Component {

    constructor(props) {
        super(props);
    }

    renderPopup = () => {
        const {title, name, appearLocally, children, close} = this.props;

        return (
            <div
                className={
                    'popup-component' +
                    (name ? ` ${name}-popup` : '') +
                    (appearLocally ? ' appear-locally' : '')
                }
            >
                <div className="overlay">
                    {
                        title ?
                            <>
                                <div className="header">
                                    <div className="title">
                                        {title}
                                    </div>
                                    {
                                        close &&
                                        <button
                                            type="button"
                                            className="popup-close-button"
                                            onClick={() => close()}
                                        >
                                            <Icon name="times"/>
                                        </button>
                                    }
                                </div>
                                <div className="body">
                                    {children}
                                </div>
                            </>
                            :
                            <>
                                {children}
                                {
                                    close &&
                                    <button
                                        type="button"
                                        className="popup-close-button"
                                        onClick={() => close()}
                                    >
                                        <Icon name="times"/>
                                    </button>
                                }
                            </>
                    }
                </div>
            </div>
        );
    };

    render() {
        const { appearLocally } = this.props;

        if (appearLocally) {
            return this.renderPopup();
        }

        return <LayoutPortal>
            {this.renderPopup()}
        </LayoutPortal>;
    }
}
